module.exports = __webpack_public_path__ + "media/src/images/Sarah-Hood-1f6b69cabc666121661a5538cb9a7813.jpg";